<template>
  <div v-if="show">
    <div class="modal is-active">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="box">
          <p>{{messages}}</p>
        </div>
      </div>
      <button class="modal-close" @click="close"></button> 
    </div>
  </div>
</template>

<script>
export default {
  props: {
    messages: {
      type: String,
      default: '',
    },
    show: {
      default: false,
      type: Boolean
    }
  },
  methods:{
    close(){
      this.$emit('child_close')
    },
  }
}
</script>
<style>
  .modal{
    z-index: 9999;
  }
</style>